export default {
  isAuthenticated(state) {
    return state.authenticated;
  },
  didAutoLogout(state) {
    return state.didAutoLogout;
  }
};
